import React, {useState} from "react";
import {useForm} from "react-hook-form";
import {Form} from 'reactstrap';
import {useIntl} from 'react-intl';
import SubmitFormButton from "../buttons/SubmitFormButton";
import {setErrors} from "../utils/formUtil";
import {toastSuccess} from "../utils/appUtil";
import handleError from "../utils/errorUtil";
import {useDispatch} from 'react-redux';
import Card from "../../core/card/Card";
import CardBody from "../../core/card/CardBody";
import CardFooter from "../../core/card/CardFooter";
import Button from "../../core/buttons/Button";
import AppForm from "../../components/forms/AppForm";

let CardForm = function ({
                             prepareData = data => data,
                             title,
                             data = {},
                             cancelText = 'Wyczyść',
                             saveText = 'Zapisano',
                             onSubmit = null,
                             getPromise = null,
                             onChange = null,
                             wasChanged = false,
                             clearFormOnSuccess = true,
                             children = null,
                             renderForm = null,
                             formContext = null
                         }) {

    let [isDuringSubmit, setIsDuringSubmit] = useState(false)

    let intl = useIntl()

    let dispatch = useDispatch()

    formContext = formContext ? formContext : useForm({defaultValues: data})

    let watch = formContext.watch

    let id = watch('id')
    React.useEffect(() => {
        const subscription = formContext.watch((data, event) => {
            if (onChange) {
                onChange(data, event)
            }
        });
        return () => subscription.unsubscribe();
    }, [watch])

    let submit = async (formData) => {
        if (prepareData) {
            formData = prepareData(formData)
        }
        setIsDuringSubmit(true)
        let result = await getPromise(id, formData)
            .then(response => {
                onSubmit(response.data)
                toastSuccess(saveText)
                if (clearFormOnSuccess) {
                    formContext.reset()
                }
            })
            .catch(error => handleError(error, dispatch))
        setErrors(result, formContext.setError, intl)
        setIsDuringSubmit(false)
    }

    React.useEffect(() => {
        formContext.reset(data)
    }, [JSON.stringify(data), formContext.reset])

    return <AppForm onSubmit={submit} formContext={formContext}>
        <Card title={title}>
            <CardBody>
                {renderForm ? renderForm(formContext) : null}
                {children}
            </CardBody>
            {(formContext.formState.isDirty || wasChanged) && <CardFooter>
                <Button variant='secondary' text={cancelText} onClick={() => formContext.reset(data)}/>
                <SubmitFormButton loading={isDuringSubmit} text='Zapisz'/>
            </CardFooter>}
        </Card>
    </AppForm>

}
export default CardForm